import type { FaireProductEntity } from "../../entity_types/product";

export const p_hp4xy6fsvd: FaireProductEntity = {
  token: "p_hp4xy6fsvd",
  type: "product",
  name: "animals watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/ce71dd5bafa5e7ade103ccef35dbfbe44ed664a2f27132cded31a9bcba783122.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b949334733b92b213059549f026d03273a03cc74b2d2c3aa5ede2529b0555c03.jpeg",
    "https://cdn.faire.com/fastly/762c31c53f8b3b5b57981195b167e4c8639fb04a20b7223142520e5573c1c656.jpeg",
    "https://cdn.faire.com/fastly/8769bac1adddd6e0fa5cb9ed5ba8925f44575aa47491a8a534e55489ecd9ce84.jpeg",
    "https://cdn.faire.com/fastly/afd7f7a9392283b19bc1f8c4c5c4b56ca398b853e4335f288c4cb8e2d240bde4.jpeg",
    "https://cdn.faire.com/fastly/b7f384f6e50f5553e097e87889ae83686fe21a4d8d3bfb3f461ea616caa5b921.jpeg",
    "https://cdn.faire.com/fastly/a2a019ea69a4caf43e3d5ece3a6839756468560b413ac1e31368a881d4a19fbb.jpeg",
    "https://cdn.faire.com/fastly/0a508e13ef871ece3d14db6ebe49ef7cc7ddee3cc44582685fef87a9ed490f3c.jpeg",
    "https://cdn.faire.com/fastly/98da02aebe4aaf5f2ff613f8915d153ecc3951aae7fae0204f60379c70b35bdf.jpeg",
    "https://cdn.faire.com/fastly/359f8e25a5bb423366f1ec99b87ce8f7d3b75b6b5724dcfc2e8bb766d8641d85.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve cheerful animals — dogs, a duck, a whale, a bunny, a deer, a frog, cats, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it a favorite for young painters and the grown-ups who paint alongside them.\n\nStrong in children's and family-focused boutiques. Pairs with the paint set and brushes for a complete birthday or holiday gift.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:08.147Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
